module.exports = __webpack_public_path__ + "static/media/corneal-shape-illustration.143b2bee.png";